import React, { ReactElement } from 'react';
import { Translate } from 'react-redux-i18n';
import { Entity, TypeEntityEnum } from '../../../../../network/api/types/compte/Entity';
import image from '../../../../../img/structure-pro/informations-generales.svg';

type Props = {
  entity: Entity,
};

const displayInformation = (
  label1: string, label2: string, long?: boolean, departementsList?: string[],
): ReactElement => (
  <div className="structure-info-row">
    <Translate value={label1 || '-'} />
    {!long ? (
      <Translate value={label2 || '-'} />
    ) : (
      <span className="with-tooltip">
        {label2}
        <div className="tooltip">
          <div className="arrow-up" />
          <div className="tooltip-content">
            {departementsList.map((departement) => (
              <>
                {departement}
                <br />
              </>
            ))}
          </div>
        </div>
      </span>
    )}
  </div>
);

function StructureGeneralInformation(props: Props): ReactElement {
  const entity = props.entity;
  return (
    <div className="structure-container structure-general">
      <div className="structure-illustration-container">
        <div className="container-img structure-illustration">
          <img
            className="structure-illustration"
            src={image}
            alt="ILLUSTRATION"
          />
        </div>
      </div>
      <div className="structure-drawer-title-container">
        <div className="structure-drawer-title">
          <Translate value="STRUCTURE_INFORMATION.GENERAL_INFOS" />
        </div>
        <div className="structure-general-informations">
          <div className="structure-info-column">
            {displayInformation('STRUCTURE_INFORMATION.ROWS.ID', entity?.id)}
            {displayInformation('STRUCTURE_INFORMATION.ROWS.TYPE', entity?.type)}
            {displayInformation('STRUCTURE_INFORMATION.ROWS.CRPCEN', entity?.crpcen)}
            {displayInformation('STRUCTURE_INFORMATION.ROWS.FORME_JURIDIQUE', entity?.ctmFormeJuridique)}
          </div>
          <div className="structure-info-column">
            {displayInformation('STRUCTURE_INFORMATION.ROWS.STATUT', entity?.statut)}
            {entity?.typeEntite === TypeEntityEnum.OFFICE
             && (
             <>
               {displayInformation('STRUCTURE_INFORMATION.ROWS.DEPARTMENT', entity?.departementDeResidence)}
               {displayInformation('STRUCTURE_INFORMATION.ROWS.RESIDENCE', entity?.residence)}
             </>
             )}
            {
              entity.name !== 'CSN' ? (entity?.typeEntite === TypeEntityEnum.INSTANCE
            && (entity?.departementsCouverts.length > 4 ? (
              displayInformation('STRUCTURE_INFORMATION.ROWS.DEPARTMENT_COUVERTS', `${entity?.departementsCouverts.length} départements`, true, entity?.departementsCouverts)
            ) : (
              displayInformation('STRUCTURE_INFORMATION.ROWS.DEPARTMENT_COUVERTS', entity?.departementsCouverts.join(', '))
            ))) : (
                displayInformation('STRUCTURE_INFORMATION.ROWS.DEPARTMENT_COUVERTS', 'Tous')
              )
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default StructureGeneralInformation;
